import { Lightbox as BaseLightbox } from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import React from "react";

function Lightbox({ slides, open, close })  {
    return  <BaseLightbox
        slides={slides}
        close={close}
        open={open}
        plugins={[Zoom, Fullscreen]}
        styles={{ container: { backgroundColor: "rgba(0, 0, 0, 0.8)" } }}
        controller={{ closeOnBackdropClick: true }}
    />
}

export default Lightbox;
